import React from 'react';
import { Box, Paper, TextField, Typography } from '@mui/material';
import {
  EMERGENCY_CONTACT_NAME_MAX,
  EMERGENCY_CONTACT_PHONE_ERROR,
  EMERGENCY_CONTACT_PHONE_MAX,
  isValidEmergencyContactPhone,
} from '../../utils/emergencyContact';

/** Required emergency contact inputs shared by the league and event registration forms. */
const EmergencyContactFields = ({ name, phone, onChange }) => {
  const phoneInvalid = phone.trim() !== '' && !isValidEmergencyContactPhone(phone);

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>Emergency Contact</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Who should we call if something happens on the field?
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
        <TextField
          name="emergencyContactName"
          label="Emergency Contact Name"
          value={name}
          onChange={onChange}
          required
          fullWidth
          slotProps={{ htmlInput: { maxLength: EMERGENCY_CONTACT_NAME_MAX } }}
        />
        <TextField
          name="emergencyContactPhone"
          label="Emergency Contact Number"
          type="tel"
          value={phone}
          onChange={onChange}
          required
          fullWidth
          error={phoneInvalid}
          helperText={phoneInvalid ? EMERGENCY_CONTACT_PHONE_ERROR : ''}
          slotProps={{ htmlInput: { maxLength: EMERGENCY_CONTACT_PHONE_MAX } }}
        />
      </Box>
    </Paper>
  );
};

export default EmergencyContactFields;
